
import { defineComponent } from "vue";
export default defineComponent({
  name: "Footer",
  data() {
    return {
      footerText: this.$t("footer")
    };
  },
   mounted() {
      const footerText = this.footerText;
      const currentYear = new Date().getFullYear();
      const updatedFooter = footerText.replace("currentYear", currentYear.toString());
      this.footerText = updatedFooter; 
  },
  computed: {
    getUpdatedFooter(): string {
      return this.footerText || "";
    }
  }
});
